const messages = {
  title: "Multiplicator de bonus",
  bandBonusTitle: "Bonus pe anvelopă cu multiplicator",
  amountLabel: "Număr minim de anvelope (*)",
  label: "Multiplicator de bonus",
  desc: "Numărul de anvelope Bridgestone și Firestone. Nu există bonus în euro pentru anvelopele Firestone.",
  goals: {
    loyal: "Loial",
    bronze: "Bronz",
    silver: "Argint",
    gold: "Aur",
    platinum: "Platină",
  },
  andMore: "și mai mult",
  chooseTarget: "Selectează",
  selectTarget: "Selectați aici obiectivul anual pentru {year}:",
  multiplication: "Bonusul se înmulțește cu <b>{factor}</b>",
  minTyres: "<b>Minim:</b> {tyre} anvelope",
};

export default {
  messages,
};
